/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const A = 1e-5, I = 3, N = 400, o = 0;
export {
  N as DEFAULT_ANIMATION_DURATION,
  I as LABEL_DECIMALS,
  A as MIN_RATIO,
  o as NO_ANIMATION
};
